import { stripHtml } from './strings';

/**
 * Shorten long validation error messages
 *
 * Runs when ENvalidate is set up
 */
export const shortenLongValidationMessages = () => {
  const LONG_MESSAGE_LENGTH = 100;
  const LONG_MESSAGE_REPLACEMENT = {
    'cy-GB': 'Caes ffurflen gorfodol yw hwn.',
    'en-GB': 'This is a mandatory form field.',
  } as { [key: string]: string };

  const locale = (window.pageJson?.locale as string) || 'en-GB';

  window.onENValidateSetupCompleteArray = window.onENValidateSetupCompleteArray || [];
  window.onENValidateSetupCompleteArray.push(() => {
    window.EngagingNetworks.validators = window.EngagingNetworks.validators.map((validator) => {
      // EN built-in error message
      if (validator.errorMessage.length >= LONG_MESSAGE_LENGTH)
        validator.errorMessage = LONG_MESSAGE_REPLACEMENT[locale] || validator.errorMessage;

      // ENvalidate error message
      if (validator.errorMessageOriginal.length >= LONG_MESSAGE_LENGTH)
        validator.errorMessageOriginal =
          LONG_MESSAGE_REPLACEMENT[locale] || validator.errorMessageOriginal;

      return validator;
    });
  });
};

/**
 * Strip HTML from error messages
 *
 * Runs when ENvalidate is set up
 */
export const stripHtmlFromValidationMessages = () => {
  window.onENValidateSetupCompleteArray = window.onENValidateSetupCompleteArray || [];
  window.onENValidateSetupCompleteArray.push(() => {
    window.EngagingNetworks.validators = window.EngagingNetworks.validators.map((validator) => {
      // EN built-in error message
      validator.errorMessage = stripHtml(validator.errorMessage);

      // ENvalidate error message
      validator.errorMessageOriginal = stripHtml(validator.errorMessageOriginal);

      return validator;
    });
  });
};
